// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2a-0N","name":"Header_name__8TjXO","birthday":"Header_birthday__ExqVS","skeleton":"Header_skeleton__2vpSt"};